import styled from "styled-components";

export const Main = styled.div`
  /* min-height: 100vh; */
  padding: 3% 0;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    /* padding: 50px 0; */
  }
`;
